<template>
  <div>
    <loading-page
      :show-loading-page="showLoadingPage"
      :loading-message="loadingMessage"
    />
  </div>
</template>
<script>
  import Constants from 'src/constants';
  import LoadingPage from 'src/views/components/LoadingPage.vue';

  export default {
    name: 'LinkValidation',
    components: {
        'loading-page': LoadingPage,
    },
    data () {
      return {
        showLoadingPage: false,
        loadingMessage: '',
      };
    },
    mounted () {
      this.startPasscodeResetting();
    },
    methods: {
      async startPasscodeResetting () {
        this.showLoadingPage = true;
        this.loadingMessage = 'Reset Passcode...';
        const externalId = this.$route.params.userId;
        const updateId = this.$route.params.linkId;
        await this.$store.dispatch('passcodereset/createLinkActiveId', {
          service_provider_id: externalId,
          update_id: updateId,
          type: Constants.SERVICE_PROVIDER_PASSCODE_RESET,
        }).then(response => {
          this.$router.push({ name: 'New Passcode' });
        }).catch(() => {
          this.$router.push({ name: 'HomePage' });
        });
      },
    },
  };
</script>
<style scoped>
.message-color {
  color: white;
}
</style>
